/**
 * <s-bundle-picker>: quantity-bundle cards (radio inputs named "quantity").
 * The checked radio is the submitted quantity; this element only mirrors the selected
 * bundle's total (data-total-formatted) and label (data-label) into:
 *   - [data-bundle-total] inside the same form (the Add to cart label)
 *   - [data-bundle-total-for="<form id>"] and [data-bundle-label-for="<form id>"] anywhere (sticky bar)
 */
class SBundlePicker extends HTMLElement {
  #onChange = (event) => {
    if (event.target instanceof HTMLInputElement && event.target.type === 'radio') this.#sync();
  };

  connectedCallback() {
    this.addEventListener('change', this.#onChange);
    this.#sync();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.#onChange);
  }

  #sync() {
    const checked = this.querySelector('input[type="radio"]:checked');
    if (!checked) return;
    const total = checked.dataset.totalFormatted || '';
    const label = checked.dataset.label || '';
    const form = checked.form;

    const totals = new Set(form ? form.querySelectorAll('[data-bundle-total]') : []);
    if (form && form.id) {
      const id = CSS.escape(form.id);
      document.querySelectorAll(`[data-bundle-total-for="${id}"]`).forEach((el) => totals.add(el));
      document.querySelectorAll(`[data-bundle-label-for="${id}"]`).forEach((el) => {
        el.textContent = label;
      });
    }
    totals.forEach((el) => {
      el.textContent = total;
    });
  }
}

if (!customElements.get('s-bundle-picker')) {
  customElements.define('s-bundle-picker', SBundlePicker);
}
